// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Account: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12">
            <path
                fill="#E4104E"
                fill-rule="evenodd"
                d="M12.75,6 L9.75,6 L9.75,3.75 L10.939,3.75 L12.75,5.562 L12.75,6 Z M11.25,10.875 C10.629,10.875 10.125,10.371 10.125,9.75 C10.125,9.129 10.629,8.625 11.25,8.625 C11.871,8.625 12.375,9.129 12.375,9.75 C12.375,10.371 11.871,10.875 11.25,10.875 L11.25,10.875 Z M3.75,10.875 C3.129,10.875 2.625,10.371 2.625,9.75 C2.625,9.129 3.129,8.625 3.75,8.625 C4.371,8.625 4.875,9.129 4.875,9.75 C4.875,10.371 4.371,10.875 3.75,10.875 L3.75,10.875 Z M14.625,8.25 L14.25,8.25 L14.25,5.562 C14.25,5.164 14.092,4.782 13.811,4.501 L12,2.691 C11.698,2.407 11.337,2.25 10.941,2.25 L9.75,2.25 L9.75,1.125 C9.75,0.504 9.246,0 8.625,0 L2.625,0 C2.004,0 1.5,0.504 1.5,1.125 L1.5,2.25 L0.354,2.25 C0.168,2.25 0,2.419 0,2.604 C0,2.831 0.168,3 0.354,3 L6.354,3 C6.581,3 6.75,3.169 6.75,3.375 C6.75,3.581 6.581,3.75 6.375,3.75 L1.125,3.75 C0.918,3.75 0.75,3.919 0.75,4.125 C0.75,4.331 0.918,4.5 1.104,4.5 L5.604,4.5 C5.831,4.5 6,4.669 6,4.875 C6,5.081 5.831,5.25 5.625,5.25 L0.375,5.25 C0.168,5.25 0,5.419 0,5.625 C0,5.831 0.168,6 0.354,6 L4.854,6 C5.081,6 5.25,6.169 5.25,6.375 C5.25,6.581 5.081,6.75 4.875,6.75 L1.5,6.75 L1.5,9.75 C1.5,10.992 2.508,12 3.75,12 C4.992,12 6,10.992 6,9.75 L9,9.75 C9,10.992 10.008,12 11.25,12 C12.492,12 13.5,10.992 13.5,9.75 L14.625,9.75 C14.831,9.75 15,9.581 15,9.375 L15,8.625 C15,8.419 14.831,8.25 14.625,8.25 L14.625,8.25 Z"
            />
        </svg>
    );
};

export default React.memo(Account);
